import React, { useEffect, useState, useRef } from "react";
import queryString from 'query-string';
import { jsonFilter, searchFilter, checkIfStuck } from "../../utils";
import Icon from "../Icon/Icon";
import { Dropdown } from "../inputs";
import { useGlobalValue } from "../../state/GlobalProvider";
import styles from "./FiltersSummary.module.sass";
const FilterSummary = props => {
  const {
    filter,
    filters,
    modifiers,
    stickyTop,
    anchor
  } = props;
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(" ");
  const filtersObj = JSON.parse(jsonFilter(filter));
  const elem = useRef(null);
  const [stuck, setStuck] = useState(false);
  const [selected, setSelected] = useState(null);
  const {
    i18n,
    history
  } = useGlobalValue();
  const removeFilter = key => {
    const newFilters = {
      ...filtersObj
    };
    Reflect.deleteProperty(newFilters, key);
    const filtersString = searchFilter(newFilters);
    const params = queryString.parse(history.location.search || "");
    const currentParams = {
      ...params,
      filter: filtersString
    };
    if (!currentParams.filter) {
      Reflect.deleteProperty(currentParams, "filter");
    }
    history.replace({
      pathname: history.location.pathname,
      search: queryString.stringify(currentParams),
      hash: anchor
    });
  };
  const updateFilter = (key, value) => {
    const newFilters = {
      ...filtersObj
    };
    newFilters[key] = value;
    const filtersString = searchFilter(newFilters);
    const params = queryString.parse(history.location.search || "");
    const currentParams = {
      ...params,
      filter: filtersString
    };
    if (!currentParams.filter) {
      Reflect.deleteProperty(currentParams, "filter");
    }
    history.replace({
      pathname: history.location.pathname,
      search: queryString.stringify(currentParams),
      hash: anchor
    });
  };
  const handleScroll = () => {
    const isStuck = checkIfStuck(elem.current, "top", stuck ? 14 : 0);
    setStuck(isStuck);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  });
  useEffect(() => {
    const handleKeyDown = e => {
      if (elem && elem.current && !elem.current.contains(e.target)) {
        setSelected(null);
      }
    };
    if (selected) {
      window.addEventListener("click", handleKeyDown);
    }
    return () => {
      window.removeEventListener("click", handleKeyDown);
    };
  }, [selected]);
  const availableFilters = (filters || []).map((filterSpec, index) => {
    const {
      prop
    } = filterSpec;
    const value = filtersObj[prop];
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: `${styles["filter-entry"]} ${value ? styles["is-active"] : ""}`,
      onClick: e => {
        const rect = {
          left: e.target.offsetLeft,
          top: e.target.offsetTop,
          right: elem.current.offsetWidth - (e.target.offsetLeft + e.target.offsetWidth),
          bottom: elem.current.offsetHeight - (e.target.offsetTop + e.target.offsetHeight)
        };
        setSelected({
          rect,
          item: filterSpec
        });
      }
    }, /*#__PURE__*/React.createElement("small", {
      className: styles["label"]
    }, /*#__PURE__*/React.createElement("span", null, prop), value && ":", " ", /*#__PURE__*/React.createElement("strong", null, value)), value && /*#__PURE__*/React.createElement("button", {
      onClick: e => {
        e.stopPropagation();
        removeFilter(prop);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      name: "remove"
    })));
  });
  let selectedFilter;
  if (selected) {
    const currentValue = filtersObj[selected.item.prop];
    const options = selected.item.list.sort((a, b) => {
      if (isNaN(a)) {
        return a.localeCompare(b);
      }
      return a - b;
    }).map(item => ({
      name: `${item}`.toLowerCase()
    }));
    let inputs;
    if (selected.item.type === "Range") {
      const [leftValue, rightValue] = (currentValue || "").split("-");
      const leftOption = currentValue !== undefined ? options.find(({
        name
      }) => name === leftValue.toLowerCase()) : "N/A";
      const rightOption = currentValue !== undefined ? options.find(({
        name
      }) => name === (rightValue || leftValue).toLowerCase()) : "N/A";
      inputs = /*#__PURE__*/React.createElement("div", {
        className: styles["filter-options"]
      }, /*#__PURE__*/React.createElement(Dropdown, {
        className: styles["dropdown"],
        value: leftOption,
        options: options,
        onChange: e => {
          updateFilter(selected.item.prop, `${e.target.value.name}-${Math.max(e.target.value.name, rightValue || leftValue)}`);
        }
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, " to: ")), /*#__PURE__*/React.createElement(Dropdown, {
        className: styles["dropdown"],
        value: rightOption,
        options: options,
        onChange: e => {
          setSelected(null);
          updateFilter(selected.item.prop, `${leftValue}-${Math.max(e.target.value.name, leftValue)}`);
        }
      }));
    } else {
      const currentOption = currentValue !== undefined ? options.find(({
        name
      }) => name === currentValue.toLowerCase()) : "N/A";
      inputs = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Dropdown, {
        className: styles["dropdown"],
        filter: true,
        value: currentOption,
        options: options,
        onChange: e => {
          setSelected(null);
          updateFilter(selected.item.prop, e.target.value.name);
        }
      }));
    }
    selectedFilter = /*#__PURE__*/React.createElement("div", {
      className: styles["filter-input-container"],
      style: selected.rect
    }, /*#__PURE__*/React.createElement("div", {
      className: styles["filter-input"]
    }, /*#__PURE__*/React.createElement("div", {
      className: styles["filter-prop"]
    }, /*#__PURE__*/React.createElement("small", null, selected.item.prop, ": ")), inputs));
  }
  const filtersContent = availableFilters.length ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles["content"]
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles["title"]} ${selected ? styles["hidden"] : ""}`
  }, /*#__PURE__*/React.createElement("small", null, i18n`Filter by`)), /*#__PURE__*/React.createElement("div", {
    className: `${styles["filters-container"]} ${selected ? styles["disabled"] : ""}`
  }, availableFilters), selectedFilter)) : null;
  if (!(filters && filters.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    ref: elem,
    style: {
      top: stickyTop
    },
    className: `${styles["root"]} ${modifiersClasses} ${stuck ? styles["stuck"] || "" : ""}`,
    stuck: stuck ? "true" : null
  }, filtersContent);
};
export default FilterSummary;